export const QUERY_KEYS = {
    AGGREGATIONS: 'aggregations',
    DRIVES: 'drives',
    COMPANIES: 'companies'
  }
  
  //maayan
//2026-05-27